import { atom } from "recoil";
import {
  EMPTY_USER,
  IModalState,
  IOmniumType,
  IPopupManagerProps,
  IRecord,
  IRecordType3,
  IRowProps,
  ISortingState,
  IUser,
  TableColumn,
} from "../Models/Entities";
import { sendData } from "../Models/Fetcher";

const getLoggedUser = async () => {
  const token = localStorage.getItem("jwt");
  if (token === null) {
    return EMPTY_USER;
  }

  const id = localStorage.getItem("userId");
  return { id: id, token: token };
};

export const customerState = atom({
  key: "cusomerState",
  default: { id: 0, name: "" },
});

export const codeTableState = atom({
  key: "codeTableState",
  default: { id: 0, name: "" },
});

export const omniumTypeState = atom({
  key: "omniumTypeState",
  default: { id: 0, name: "" },
});

export const updatedRecord = atom<IRecord | null>({
  key: "updatedRecords",
  default: null,
});

export const selectedTypesState = atom<IOmniumType[]>({
  key: "selectedTypesState ",
  default: [],
});

export const loggedUserState = atom({
  key: "loggedUserState",
  default: getLoggedUser(),
});

export const popupState = atom<IPopupManagerProps | null>({
  key: "popupState",
  default: null,
});

export const refreshTables = atom<number>({
  key: "refreshTables",
  default: -1,
});

export const sortingState = atom<ISortingState>({
  key: "sortState",
  default: { column: TableColumn.OmniumValues, ascending: true },
});

export const selectedTableName = atom<string>({
  key: "selectedTableName",
  default: "",
});

export const updatedRecordType3 = atom<IRecordType3 | null>({
  key: "updatedRecord3",
  default: null,
});

export const codeTableTypeState = atom<number>({
  key: "odeTableTypeState",
  default: 2,
});

export const actionState = atom<any>({
  key: "actionState",
  default: null,
});

export const toastState = atom<IModalState>({
  key: "modalState",
  default: { open: false, severity: "", message: "" },
});
